import { useMutation } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { AcceptOrganizationInvitationDto } from "../../../models/organization/dto/accept-organization-invitation.dto";

export const useAcceptOrganizationInvitation = () => {
    const apiClient = useApiClient();

    return useMutation({
        mutationKey: ['acceptOrganizationInvitation'],
        mutationFn: async (dto: AcceptOrganizationInvitationDto) => {
            return apiClient.fetchApi({ method: 'POST', endpoint: 'organizations/accept-invitation', body: dto });
        }
    });
};